import styled from "@emotion/styled";
export const SelectTokensContainer = styled.div`
  margin-right: 4px;
  font-size: 20px;
  font-weight: 500;
  color: #38da7c !important;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
`;
